module.exports = __webpack_public_path__ + "static/media/Anorith_gaussian2.a4362495.png";